import { render } from "./Stream.vue?vue&type=template&id=4225f4d2"
import script from "./Stream.vue?vue&type=script&lang=js"
export * from "./Stream.vue?vue&type=script&lang=js"

import exportComponent from "C:\\projects\\apps\\appKonferenceStudioW\\v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__